/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
// import PropTypes from 'prop-types';
/* eslint-enable no-unused-vars */

import Main from '../../../../../phase2/survey/Main';
import { connector } from '../../../../broadcast';
// Redux.store と結びつける - popup Main wrap します
const MainConnector = connector(Main);
export default MainConnector;



// WEBPACK FOOTER //
// ./src/embedded-type/survey/page/widget/sequence/MainConnector.js